import React, { useCallback, useEffect, useState } from "react";
import DataTable from "../../components/Common/DataTable";
import * as url from "../../helpers/url_helper";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs4";
import { convertLocalDate } from "../../Utils/configController";
import Request from "../../helpers/request";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import moment from "moment";

const Feedback = () => {
  const [dataTableId, setDataTableId] = useState<any>(null);
  const [isOpenFeedbackModel, setOpenFeedbackModel] = useState<boolean>(false);
  const [feedbackData, setFeedbackData] = useState<any>(false);
  const [replyText, setReplyText] = useState<string>("");
  const [replyLoading, setReplyLoading] = useState<boolean>(false);

  const reloadDataTable = useCallback(() => {
    if (dataTableId) {
      const dataTableInstance: any = $(`#${dataTableId}`).DataTable();
      dataTableInstance.ajax.reload(null, false);
    }
  }, [dataTableId]);

  const handleDataTableIdChange = (dataTableId: any) => {
    // Now you have access to the DataTable ID here
    // console.log('DataTable ID:', dataTableId);
    setDataTableId(dataTableId);
    // You can do whatever you need with the ID in this component
  };

  const changeStatusApiCall = (values: any, id: string) => {
    const reqObj = {
      feedbackId: id,
      status: values,
    };
    Request.post(url.CHANGE_STATUS_URL, reqObj)
      .then((res) => {
        toast.success(res?.data?.msg || "Status updated");
        reloadDataTable();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.errors?.[0]?.msg || "Failed to update status",
        );
      });
  };

  const renderExpandedRow = (rowData: any) => {
    if (!rowData) return "";
    return `
            <div style="padding-top: 10px; padding-bottom: 10px; background:#f9fafb; border-radius:6px;">
                <strong>Reply:</strong> ${
                  rowData?.adminReply
                    ? `<span>${rowData.adminReply}</span>`
                    : `<span>No reply yet</span>`
                }
            </div>
        `;
  };

  const columns = [
    {
      title: "",
      render: function (data: any, type: any, row: any) {
        if (!row) return "";
        if (row?.adminReply) {
          return `<span class="details-control" style="cursor:pointer;">
                              <i class="bx bx-caret-right text-dark fs-5"></i>
                          </span>`;
        }
        return "";
      },
      orderable: false,
      width: "30px",
    },
    {
      title: "#ID",
      render: function (data: any, type: any, row: any) {
        if (!row) return "-";
        const joinArray = [row?.userId?.mobile, row?.userId?.email].filter(
          Boolean,
        );
        return `<div><div>${
          joinArray.length ? joinArray.join(" | ") : "-"
        }</div></div>`;
      },
    },
    {
      title: "Feedback",
      render: function (data: any, type: any, row: any) {
        if (!row) return "-";
        return `<div class="d-flex gap-2"><span style="width:200px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${
          row?.feedback ? row.feedback : "-"
        } </span> </div>`;
      },
    },
    {
      title: "Status",
      render: function (data: any, type: any, row: any) {
        if (!row) return "-";
        let statusLabel = "-";
        let color = "#6b7280";
        let bg = "#f3f4f6";
        let border = "#e5e7eb";

        if (row.status === 0) {
          statusLabel = "Pending";
          color = "#2563eb";
          bg = "#eff6ff";
          border = "#bfdbfe";
        } else if (row.status === 1) {
          statusLabel = "Replied";
          color = "#16a34a";
          bg = "#f0fdf4";
          border = "#bbf7d0";
        } else if (row.status === 2) {
          statusLabel = "Closed";
          color = "#e11d48";
          bg = "#fef2f2";
          border = "#fecdd3";
        }
        return `<span style="display: inline-block; color: ${color}; background-color: ${bg}; border: 1px solid ${border}; padding: 3px 8px; border-radius: 999px; font-size: 12px; font-weight: 500;">${statusLabel}</span>`;
      },
    },
    {
      title: "Created At",
      render: function (data: any, type: any, row: any) {
        if (!row?.createdAt) return "-";
        const date = moment(row.createdAt, "D/M/YYYY, h:mm:ss a", true);
        return date.isValid() ? date.format("YYYY-MM-DD HH:mm:ss.SSS") : "-";
      },
    },
    {
      title: "Updated At",
      render: function (data: any, type: any, row: any) {
        if (!row?.updatedAt) return "-";
        const date = moment(row.updatedAt, "D/M/YYYY, h:mm:ss a", true);
        return date.isValid() ? date.format("YYYY-MM-DD HH:mm:ss.SSS") : "-";
      },
    },
    {
      title: "Actions",
      render: function (data: any, type: any, row: any) {
        if (!row) return "-";
        const isClosed = row?.status === 2;
        const isPending = row?.status === 0;

        return `
                  <div style="display:flex; gap:6px;">
                      <button class="edit-btn" style="border: none; outline: none; background: none;" type="button" >
                          <span class="badge bg-primary" style="height: 25px; width: 60px; font-size: 12px; padding: 6px;">${
                            isPending ? "Reply" : "View"
                          }</span>
                      </button>
                      ${
                        !isClosed
                          ? `<button class="close-btn" style="border: none; outline: none; background: none;" type="button" >
                                      <span class="badge" style="height: 25px; width: 60px; font-size: 12px; padding: 6px; background-color:#e11d48; color:#fff;">Close</span>
                                </button>`
                          : ""
                      }
                  </div>
              `;
      },
    },
  ];

  const handleCloseIssue = useCallback(
    (rowData: any) => {
      if (!rowData?._id) {
        toast.error("Invalid feedback id");
        return;
      }
      changeStatusApiCall(2, rowData._id);
    },
    [changeStatusApiCall],
  );

  useEffect(() => {
    if (!dataTableId) return;

    const $table = $(`#${dataTableId}`);

    $table.off("click", ".close-btn").on("click", ".close-btn", function () {
      const dt: any = $table.DataTable();
      const rowData = dt.row($(this).parents("tr")).data();
      handleCloseIssue(rowData);
    });

    return () => {
      $table.off("click", ".close-btn");
    };
  }, [dataTableId, handleCloseIssue]);

  const handleViewFeedback = (rowData: any) => {
    setOpenFeedbackModel(true);
    // const beautifiedJSON = JSON.stringify(rowData.response, null, 2);
    setFeedbackData(rowData);
    setReplyText(rowData?.adminReply || "");
  };

  const toggleFeedbackModel = () => {
    setOpenFeedbackModel(!isOpenFeedbackModel);
    if (isOpenFeedbackModel) {
      setFeedbackData(null);
      setReplyText("");
    }
  };

  const handleSendReply = () => {
    if (!replyText.trim()) {
      toast.error("Please enter a reply before sending.");
      return;
    }
    setReplyLoading(true);
    const reqObj = {
      feedbackId: feedbackData?._id,
      reply: replyText,
    };
    Request.post(url.REPLY_FEEDBACK, reqObj)
      .then((res) => {
        toast.success(res?.data?.msg || "Reply sent successfully");
        reloadDataTable();
        setReplyLoading(false);
        setOpenFeedbackModel(false);
        setFeedbackData(null);
        setReplyText("");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.errors?.[0]?.msg || "Failed to send reply",
        );
        setReplyLoading(false);
      });
  };
  return (
    <div>
      <ToastContainer />

      <Modal
        isOpen={isOpenFeedbackModel}
        role="dialog"
        autoFocus={true}
        centered={true}
        size="lg"
        className="exampleModal"
        toggle={toggleFeedbackModel}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleFeedbackModel}>{"Feedback"}</ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <label className="fw-bold mb-1 d-block">Subject</label>
              <div className="p-2 border rounded bg-light ">
                {feedbackData?.subject || "-"}
              </div>
            </div>

            <div className="mb-3">
              <label className="fw-bold mb-1 d-block">Issue</label>
              <div
                className="p-2 border rounded bg-light"
                style={{ minHeight: "60px", whiteSpace: "pre-wrap" }}
              >
                {feedbackData?.feedback || "-"}
              </div>
            </div>

            <div className="d-flex gap-4 mb-3">
              <div>
                <label className="fw-bold mb-1 d-block">Email</label>
                <div>
                  {feedbackData?.email || feedbackData?.userId?.email || "-"}
                </div>
              </div>
              <div>
                <label className="fw-bold mb-1 d-block">Mobile</label>
                <div>
                  {feedbackData?.mobile || feedbackData?.userId?.mobile || "-"}
                </div>
              </div>
            </div>

            <div className="mb-2">
              <label className="fw-bold mb-1 d-block">Reply</label>
              {feedbackData?.adminReply ? (
                feedbackData?.adminReply
              ) : (
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Type your reply here..."
                  value={replyText}
                  onChange={(e) => setReplyText(e.target.value)}
                />
              )}
            </div>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center" }}>
            <button
              className="btn btn-secondary"
              type="button"
              onClick={() => setOpenFeedbackModel(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-dark"
              type="submit"
              disabled={replyLoading || feedbackData?.adminReply}
              onClick={handleSendReply}
            >
              {replyLoading ? "Sending..." : "Submit"}
            </button>
          </ModalFooter>
        </div>
      </Modal>

      <DataTable
        apiURL={`${url.BASE_URL}${url.GUEST_FEEDBACK_URL}`}
        columns={columns}
        // responseType={{ recordsTotal: 0, recordsFiltered: 0, data: [] }}
        isAddBtnShow={false}
        isBtnShow={false}
        handleDeleteClick={() => {}}
        // handleEditbtn={() => { }}
        isShowSearch={false}
        onDataTableRefresh={handleDataTableIdChange}
        handleEditClick={handleViewFeedback}
        idName={"Feedback"}
        renderExpandedRow={renderExpandedRow}
        handleCloseClick={handleCloseIssue}
      />
    </div>
  );
};

export default Feedback;
